import { Sparkles } from "lucide-react";

const LABELS = {
  isee: { text: "ISEE", color: "#009966", bg: "#00996615" },
  "730_cu": { text: "730 / CU", color: "#0A0A0A", bg: "#0A0A0A15" },
  both: { text: "ISEE + 730", color: "#8A2BE2", bg: "#8A2BE215" },
};

export default function TaxBadge({ relevance, size = "sm", withIcon = true }) {
  if (!relevance || relevance === "none") return null;
  const cfg = LABELS[relevance];
  if (!cfg) return null;
  const cls = size === "lg" ? "text-xs px-2.5 py-1" : "text-[10px] px-2 py-0.5";
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-xl uppercase tracking-widest font-medium border ${cls}`}
      style={{ color: cfg.color, background: cfg.bg, borderColor: `${cfg.color}30` }}
      data-testid={`tax-badge-${relevance}`}
    >
      {withIcon && <Sparkles className="w-3 h-3" />}
      {cfg.text}
    </span>
  );
}
